import { render, staticRenderFns } from "./listaLaboratorio.vue?vue&type=template&id=e3aa978c&scoped=true&"
import script from "./listaLaboratorio.vue?vue&type=script&lang=js&"
export * from "./listaLaboratorio.vue?vue&type=script&lang=js&"
import style0 from "./listaLaboratorio.vue?vue&type=style&index=0&id=e3aa978c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aa978c",
  null
  
)

export default component.exports